initReviews = function(){
    const swiper = new Swiper(".swiper-custom", {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1200: {
                slidesPerView: 3
            }
        },
    });

    const updatePaginationClass = () => {
        // We're looking for the .swiper-pagination-lock class added to the pagination dots element. If this class
        // is present, the dots have been hidden and we need to add a class to the entire swiper element to pull up the
        // "Read All Reviews" CTA
        const paginationLock = swiper.el.querySelector('.swiper-pagination-lock');
        paginationLock ? swiper.el.classList.add('pagination-locked') : swiper.el.classList.remove('pagination-locked');
    }

    swiper.on('resize', updatePaginationClass);
    // swiper.on('breakpoint', updatePaginationClass);
}

// check to see if we are on the frontend or in admin
if ( window.acf ) {
    // initialize dynamic block preview (editor)
    window.acf.addAction( 'render_block_preview/type=reviews-slider', initReviews);
}
else {
    // initialize on frontend
    initReviews();
}
